import axios from "axios";
import ManagerService from "./ManagerService";

// USING AI SERVICE TO INTERACT DIRECTLY WITH ELASTICSEARCH AND USE THE BID-CHATTO-LLM LIBRARY TO CREATE EMBEDDINGS
const CacheService = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_CHAT_AI_ENDPOINT + "/api/v1/cache",
    headers: {
      "Content-Type": "application/json",
      "X-XSS-Protection": "X-XSS-Protection: 1; mode=block",
      "X-Frame-Options": "SAMEORIGIN",
      "Strict-Transport-Security": "max-age=10000000",
      "Content-Security-Policy": "default-src 'self'; child-src 'none';",
      "Referrer-Policy": "no-referrer",
      "X-Content-Type-Options": "nosniff",
      Authorization: "Bearer " + localStorage.getItem("localAuthorization"),
    },
  };

  let instance = axios.create(defaultOptions);

  return instance;
};

export default CacheService();

const storeCache = async (payload) => {
  const res = await CacheService().post(`/store`, payload);
  if (res.status === 200) {
    return res.data;
  }
};

const getCache = async (payload) => {
  const res = await CacheService().post(`/`, payload);
  if (res.status === 200) {
    return res.data;
  }
};

const storeBulkCache = async (file) => {
  const formdata = new FormData();
  formdata.append(`file`, file, file.name);

  const res = await CacheService().post(`/store_bulk`, formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.status === 200) {
    return res.data;
  }
};

// USING MANAGER SERVICE TO INTERACT WITH THE MANAGER API TO MANAGE THE CACHE

const getChatbotVerifiedAnswers = async (chatbot_name) => {
  const res = await ManagerService.get(
    `/companies/${localStorage.getItem(
      "company_id"
    )}/chatbots/${chatbot_name.toLowerCase()}/cache`
  );
  if (res.status === 200) {
    return res.data;
  }
};

const deleteVerifiedQA = async (chatbot_name, doc_id) => {
  const res = await ManagerService.delete(
    `/companies/${localStorage.getItem(
      "company_id"
    )}/chatbots/${chatbot_name.toLowerCase()}/cache/${doc_id}`
  );
  if (res.status === 200) {
    return res.data;
  }
};

const downloadVerifiedQA = async (chatbot_name) => {
  const res = await ManagerService.get(
    `/companies/${localStorage.getItem(
      "company_id"
    )}/chatbots/${chatbot_name.toLowerCase()}/cache/download`,
    {
      responseType: "blob",
    }
  );
  if (res.status === 200) {
    return res.data;
  }
};

export {
  storeCache,
  getCache,
  storeBulkCache,
  getChatbotVerifiedAnswers,
  deleteVerifiedQA,
  downloadVerifiedQA,
};
